// DOMの読み込みが完了してからスクリプトを実行
document.addEventListener("DOMContentLoaded", function() {
  // 画面幅が768px以下（スマホサイズ）の場合のみ実行
  if (window.innerWidth <= 768) {
    // スクロールしたかどうかを記録するフラグ
    let hasScrolled = false;

    // 対象となる要素を取得
    const headerSearch = document.querySelector('.header__search-SP');

    // スクロールイベントを監視
    window.addEventListener('scroll', function() {
      // 現在のスクロール位置を取得
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // 下にスクロールしたとき（スクロール位置が0より大きい）かつ、まだ非表示にしていないとき
      if (scrollTop > 0 && !hasScrolled) {
        if (headerSearch) headerSearch.style.display = 'none'; // 要素を非表示にする
        hasScrolled = true; // 一度非表示にしたことを記録
      }
      // スクロール位置が一番上に戻ったとき（ページトップ）
      else if (scrollTop === 0) {
        if (headerSearch) headerSearch.style.display = 'block'; // 要素を再表示する
        hasScrolled = false; // フラグをリセット
      }
    });
  }
});
